import {
  ApplicationRef,
  ComponentFactoryResolver,
  ComponentRef,
  Injectable,
  Injector
} from '@angular/core';
import { ModalComponent } from './modal.component';
import { ModalSharedService } from './modal.sharedService';

@Injectable()
export class ModalService {
  public componentRef: ComponentRef<any>;
  private containerEl = document.querySelector('body');
  private uniqueKey: number;

  constructor(
    private resolver: ComponentFactoryResolver,
    private applicationRef: ApplicationRef,
    private injector: Injector,
    private modalSharedService: ModalSharedService
  ) { }
  createModalComponent(component: any, data?: any) {
    this.uniqueKey = this.modalSharedService.generateUniqueKey();
    this.modalSharedService.setInstance(this, this.uniqueKey);
    const componentFactory = this.resolver.resolveComponentFactory(component);
    this.componentRef = componentFactory.create(this.injector);
    this.applicationRef.attachView(this.componentRef.hostView);
    this.containerEl.appendChild(this.componentRef.location.nativeElement);
    if (data) {
      this.componentRef.instance.data = data;
    }
    this.openModal();
    return this.componentRef;
  }
  openModal() {
    let modalInstance;
    for (const key in this.componentRef.instance) {
      if (this.componentRef.instance[key] instanceof ModalComponent) {
        modalInstance = this.componentRef.instance[key];
        this.componentRef.instance[key].uniqueKey = this.uniqueKey;
      }
    }
    if (modalInstance) {
      modalInstance.open();
    }
  }
  destroyModalComponent() {
    if (this.componentRef) {
      const modalElement = this.componentRef.location.nativeElement;
      if (modalElement && modalElement.parentNode) {
        modalElement.parentNode.removeChild(modalElement);
      }
      this.componentRef.destroy();
    }
  }
}
